
import React, { useState,useEffect } from 'react';
import axios from 'axios'
import CommonVars from '../Component/CommonVars';
import {
    Flex,
    Box,
    Image,
    VStack,
    Button,
    Link,
    HStack,
    Input,
    useNumberInput,
    useToast
  } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';



function ProductDetails(){
    const [products,setProductDetail] = useState('')
    const [reviews,setReview] = useState('');

 useEffect(() => {
    getProductDetails()
    getReview()
 },[])

const productId = useParams().productId;

const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } =
    useNumberInput({
      step: 1,
      defaultValue: 0,
      min: 0,
      max: 99
    })
    const inc = getIncrementButtonProps()
    const dec = getDecrementButtonProps()
    const input = getInputProps()

const getProductDetails = async() =>{
    axios.get(`${CommonVars.API_URL}/products/${productId}`  )
    .then((res) =>{
        const ProductDetails = res.data[0];
        console.log(ProductDetails);
        setProductDetail(ProductDetails);
    }).catch((err)=>{
        console.log(err)
    })
}

const getReview = async() =>{
    axios.get(`${CommonVars.API_URL}/reviews/${productId}`)
    .then((res) =>{
        const Reviewsdata = res.data;
        setReview(Reviewsdata);
    }).catch((err) =>{
        console.log(err)
    })
}

const DeleteProduct = async() =>{
    const token = localStorage.getItem('token')
    console.log(productId)
    axios.delete(`${CommonVars.API_URL}/products/${productId}`,{headers:{Authorization : `Bearer ${token}`} })
    .then((res) =>{
        console.log(res)
        window.location.replace('/')
    }).catch((err) =>{
        console.log(err)
    })
}
const toast = useToast();
const id = 'addCart-toast';

const handleSubmit = (e) => {
    e.preventDefault();

    if(localStorage.getItem('token') !== null){
        const userid = localStorage.getItem('loggedInUserID');
        const token = localStorage.getItem('token');

        const qty = parseInt(input.value);

        const requestBody = {
            productid: productId,
            quantity: qty
        }

        console.log(requestBody)
        
        if(qty !== 0){
            axios.post(`${CommonVars.API_URL}/carts/${userid}`, requestBody,
                { headers: { Authorization: `Bearer ${token}` } }
            )
                .then(() => {
                    if(!toast.isActive(id)){
                        toast({
                            id,
                            title: 'Success!',
                            description: 'Product successfully added to cart!',
                            status: 'success',
                            position: 'top',
                            duration: 3000,
                            isClosable: true,
                        });
                    }

                    setTimeout(() => {
                        window.location.replace('/carts');
                    }, 2000)
                })
                .catch((err) => {
                    console.log(err);
                    if(!toast.isActive(id)){
                        toast({
                            id,
                            title: 'Error!',
                            description: 'Add to cart error!',
                            status: 'error',
                            position: 'top',
                            duration: 3000,
                            isClosable: true,
                        });
                    }
                })
        } 
        else {
            if(!toast.isActive(id)){
                toast({
                    id,
                    title: 'Error!',
                    description: 'Please enter quantity!',
                    status: 'error',
                    position: 'top',
                    duration: 3000,
                    isClosable: true,
                });
            }
        }
    }
    else {
        window.location.replace('/login');
    }
}
    const aProductDetails = [];
    aProductDetails.push(
        <Box bg={'gray.100'} h={'300'} w={'800'} rounded={'lg'} marginInline={'300'}>
            
            <Flex>
                    <Image
                    boxSize={'300'}
                    rounded={'lg'}
                    src={products.image}
                    alt = {`Picture of ${products.name}`}
                    />
                    <VStack>
                        <Box
                        marginInlineStart={'8'}
                        marginTop={'5'}
                        fontWeight={'bold'}
                        fontSize={'4xl'}
                        >
                        {products.name}
                        </Box>
                        <Box
                        fontSize={'large'}
                        fontWeight={'semibold'}
                        >
                        Price: ${products.price}
                        </Box>
                        <Box
                        fontSize={'large'}
                        fontWeight={'semibold'}
                        >  
                        Description: 
                        </Box>
                        <Box 
                        fontSize={'medium'}
                        fontWeight={'semibold'}
                        >
                        {products.description}
                        </Box>
                    </VStack>
                    <VStack >

                    <HStack marginTop={'100'} maxW='450px'>
                        <Button bg={'white'} {...inc}>+</Button>
                        <Input bg={'white'} w={'20'} {...input} />
                        <Button bg={'white'} {...dec}>-</Button>
                    </HStack>
                    <HStack>
                    <Box>
                        {
                            localStorage.getItem('token') === null ?
                            <>
                            <Button bg={'white'}>
                             <Link href={`/login`}>
                                 Add Review
                                 </Link>
                            </Button>
                            </> :
                             <Button bg={'white'}>
                             <Link href={`/AddReview/${productId}`}>
                                 Add Review
                                 </Link>
                            </Button>

                        }
                    </Box>
                    <Box >
                        <Button bg={'white'} onClick={handleSubmit}>
                            <Link href={`/carts`} >
                            Add To Cart
                            </Link>
                        </Button>
                    </Box>
                    
                    </HStack>
                    {
                        localStorage.getItem('role') == 'admin' ?
                        <>
                        <Box >
                        <Button bg={'white'} onClick={DeleteProduct}>
                            Delete Product
                        </Button>
                    </Box>
                        </> :
                        null

                    }
                    </VStack>
                    
                </Flex>   
            </Box>

       
    )

    const aReviews = [];

    for( var i = 0; i < reviews.length; i++){
        aReviews.push(
        <Box w={'500'} bg={'white'} rounded={'lg'}  margin={'20px'}  justifyContent={'center'}>
            <Flex>
                <Box paddingInlineStart={'5'} paddingTop={'10px'} bg={'gray.100'} w={'full'}>
                    <Flex>
                    <Box fontWeight={'semibold'}>User:  </Box>
                        <Box fontWeight={'semibold'}> {reviews[i].username}</Box>
                    </Flex> 
                    <Box   fontWeight={'semibold'}>Rating: {reviews[i].rating}</Box>
                    <Box fontWeight={'semibold'}>Reviews: {reviews[i].review}</Box>
                </Box>
            </Flex>
        </Box>

            
             
          
        )
    }    

    return(
   
        <Box bg={'white'}> 
            <Box paddingInline={'10px'} fontWeight={'semibold'} fontSize={'3xl'}>
                Product Detail
            </Box>
    
            {aProductDetails}
            <Box  w={'500'}>
            <Box paddingInline={'10px'} fontWeight={'bold'} fontSize={'3xl'}>
                Reviews
            </Box>
            { 
                aReviews !== null ?
                <>
                <Box>
                {aReviews}
                </Box>
                
                </> :

                <Box  fontSize={'2xl'} fontWeight={'semibold'}>
                There is no reviews on this product.
                </Box>
                
            }
            
            </Box>
        </Box>
    )
}

export default ProductDetails